import { connect } from 'react-redux';
import actions from '../actions';

import ProbingPane from '../components/ProbingPane';

export default connect(
  (state, ownProps) => {
    const {
      width,
      visible,
      currentTab,
    } = state.ui.probingPane;
    const {
      visible: showTitleBar
    } = state.ui.titleBar;
    return {
      width,
      visible,
      currentTab,
      hideTitleBar: !showTitleBar
    }
  },
  (dispatch, ownProps) => ({
    onTabChange: (e,i) => dispatch(actions.ui.probingPane.setTab(i))
  })
)(ProbingPane);
